export default "__VITE_ASSET__7a746d7c__"